import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/venues', params),
    getById: (id) => Api.get('/cent/venue/' + id, null),
    save: (entity) => Api.post('/cent/venue', entity),
    update: (id, entity) => Api.put('/cent/venue/' + id, entity),
    delete: (id)=> Api.delete('/cent/venue/' + id),
    search: (searchText) => Api.get('/cent/venues/search', {q: searchText}),
    getLocations: (id) => Api.get('/cent/venue/' + id + '/locations', null),
    addLocation: (id, locationId) => Api.post('/cent/venue/' + id + '/location/' + locationId),
    removeLocation: (id, locationId) => Api.delete('/cent/venue/' + id + '/location/' + locationId),
    listAssets: (id) => Api.get('/cent/venue/' + id + '/assets', null),
    addAsset: (id, assetId) => Api.post(`/cent/venue/${id}/asset/${assetId}`),
    removeAsset: (id, assetId) => Api.delete(`/cent/venue/${id}/asset/${assetId}`),
    saveAsset: (id, asset) => Api.post('/cent/venue/' + id + '/asset', asset),
    getEvents: (id, data) => Api.get('/cent/venue/' + id + '/events', data),
    getStatuses: () => Api.get('/cent/venue/statuses', null),
    getContacts: (id) => Api.get('/cent/venue/' + id + '/contacts'),
    addContact: (id, contactId) => Api.put('/cent/venue/' + id + '/contact', {contactId: contactId}),
    removeContact: (id, contactId) => Api.delete('/cent/venue/' + id + '/contact/' + contactId),
};